import {RangeTuple} from 'fuse.js'
import React from 'react'

export const MarkText = ({children, marks}: {children: string; marks?: readonly RangeTuple[]}) => {
  let markedText: React.ReactNode[] = []
  let lastIndex = 0
  if (marks == null) return children
  marks.forEach(([start, end], index) => {
    markedText.push(children.substring(lastIndex, start))
    markedText.push(<mark key={`${start}-${end}-${index}`}>{children.substring(start, end + 1)}</mark>)
    lastIndex = end + 1
  })
  markedText.push(children.substring(lastIndex))
  return markedText
}

/** like MarkText but returns markdown text */
export const markMd = ({md, marks}: {md: string; marks?: readonly RangeTuple[]}) => {
  if (marks == null) return md
  let markedText: string[] = []
  let lastIndex = 0
  marks.forEach(([start, end]) => {
    markedText.push(md.substring(lastIndex, start))
    markedText.push(`<mark>${md.substring(start, end + 1)}</mark>`)
    lastIndex = end + 1
  })
  markedText.push(md.substring(lastIndex))
  return markedText.join('')
}
